import { PropsWithChildren } from "react";
import { Grid, useTheme } from "@mui/material";

const Auth = ({ children }: PropsWithChildren) => {
  const theme: any = useTheme();

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      display="flex"
      flexDirection="column"
      sx={{ backgroundColor: theme.palette.grey[900], minHeight: "100vh" }}
    >
      {children}
    </Grid>
  );
};

export default Auth;
